// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const emailDomain = process.env.REACT_APP_EMAIL_DOMAIN || 'hacettepe.edu.tr';

const resources = {
  en: {
    translation: {
      "Course":"Course",
      "swap_points":"Change Points", 
      "konumumu_kullan": "Use My Location",
      "arama_hatasi": "An error occurred during the search.",
      "geolocation_destegi_yok": "Geolocation API is not supported.",
      "konumum": "My Location",
      "konum_alindi": "Your location was obtained successfully.",
      "konum_alinirken_hata": "An error occurred while obtaining your location.",
      "baslangic_noktasi": "Start Point",
      "vasita_turu": "Transport Mode",
      "yaya": "Walking",
      "bisiklet": "Cycling",
      "arac": "Driving",
      "rota_hesapla": "Calculate Route",
      "arama": "Search",
      "ara": "Search",
      "Cultural and Artistic Events":"Cultural and Artistic Events",
      "Symposium":"Symposium",
      "Career and Entrepreneurship":"Career and Entrepreneurship",
      "hacettepe": "Hacettepe",
      "harita":"Map",
      "street_view": "Street View",
      "events": "Events",
      "add_event": "Add Event",
      "add_unit": "Add Unit",
      "add_error": "Add Error",
      "bitis_noktasi": "End Point",
      "baslangic": "Start",
      "bitis": "End",
      "etkinlik_detaylari": "Event Details",
      "tarih": "Date",
      "saat": "Time",
      "yer": "Location",
      "tur": "Type",
      "iletisim": "Contact",
      "aciklama": "Description",
      "cancel": "Cancel",
      "save": "Save",
      "street_view_instructions": "Click on the map to select a point for street view.",
      "yandex_street_view_opening": "Yandex Street View is opening...",
      "unit_fields_required": "Name, Latitude, and Longitude are required.",
      "invalid_coordinates": "Please enter valid coordinates.",
      "unit_updated": "Unit updated successfully.",
      "unit_update_error": "There was an error updating the unit.",
      "event_not_found": "Event data not found.",
      "all_fields_required": "All fields are required.",
      "event_updated": "Event updated successfully.",
      "event_update_error": "There was an error updating the event.",
      "route_calculated": "Route calculated successfully.",
      "route_not_found": "Route not found.",
      "route_error": "There was an error calculating the route.",
      "reverse_geocoding_error": "An error occurred while retrieving the location name.",
      "show_details": "Show Details",
      "distance_label": "Distance:",
      "mesafe_unit": "m",
      "edit_unit": "Edit Unit",
      "name": "Name",
      "description": "Description",
      "latitude": "Latitude",
      "units": "Units",
      "longitude": "Longitude",
      "login_form_title": "Login",
      "login_username": "Username",
      "login_password": "Password",
      "login_button": "Log In",
      "login_missing_fields": "Please enter username and password.",
      "login_failed": "Login failed",
      "login_error": "An error occurred during login.",
      "register_form_title": "Register",
      "register_username": "Username",
      "register_password": "Password",
      "register_role_label": "Select Role",
      "role_normal": "Normal",
      "role_editor": "Editor",
      "role_admin": "Admin",
      "register_button": "Register",
      "register_missing_fields": "Please fill all fields.",
      "register_success": "Registration successful! You can now log in.",
      "register_failed": "Registration failed",
      "register_error": "An error occurred during registration.",
      "login_success": "Login successful!",
      "haritadan_secmek_icin_haritaya_tiklayin":"Please choose from the closed area",
      "logout_success": "Logged out.",
      "select_start_end": "Please select both start and end points.",
      "route_calculating": "Calculating route...",
      "search_navigating": "Navigating to search result...",
      "select_start_instruction": "Click on the map to select the start point.",
      "select_end_instruction": "Click on the map to select the end point.",
      "start_point_selected": "Start point selected.",
      "end_point_selected": "End point selected.",
      "unit_selected": "selected.",
      "unit_panel": "Units",
      "welcome_message": "Welcome, {{username}}",
      "logout_button": "Log Out",
      "birimler": "Units",
      "hatalar": "Errors",
      "search_unit": "Search Unit",
      hacettepe: process.env.REACT_APP_SIDEBAR_LABEL || 'Hacettepe',
      "units_fetch_error": "There was a problem loading units.",
      "edit_event":"Edit Event",
      "confirm_delete_event": "Are you sure you want to delete this event?",
      "event_deleted": "Event successfully deleted.",
      "event_delete_error": "An error occurred while deleting the event.",
      "delete_event":"Delete Event",
      "edit_unit":"Edit Unit",
      "standart_page":"Standart",
      "satellite_page":"Satellite",
      "searchInUnits":"Search Units...",
      "goto_here":"Go to Here",
      "register_missing_fields":       "Please fill in all fields",
      "register_password_mismatch":    "Passwords do not match",
      "register_invalid_email":        "Invalid email address",
      "register_form_title":           "Registration Form",
      "register_name":                 "Name",
      "register_surname":              "Surname",
      "register_email":                "Email",
      "register_username":             "Username",
      "register_password":             "Password",
      "register_confirm_password":     "Confirm Password",
      "register_role_label":           "Role",
      "role_editor":                   "Editor",
      "role_admin":                    "Administrator",
      "register_loading":              "Registering…",
      "register_check_email":          "Please check your email",
      "register_failed":               "Registration failed",
      "register_error":                "An error occurred during registration",
      "login_form_title":     "Log In",
      "login_email":          "Email",
      "login_password":       "Password",
      "login_missing_fields": "Please enter email and password",
      "login_inactive":       "Your account is not active. Please check your email",
      "login_failed":         "Login failed",
      "login_error":          "An error occurred during login",
      "add_unit":"Add Unit",
        "add_unit": "Add Unit",
  "name": "Name",
  "description": "Description",
  "website": "Website",
  "telephone": "Telephone",
  "location": "Location",
  "cancel": "Cancel",
  "add": "Add",
  "clear_map": "Clear Map",
  
  "title": "Title",
  "date": "Date",
  "time": "Time",
  "location": "Location",
  "eventType": "Event Type",
  "Seminar": "Seminar",
  "Workshop": "Workshop",
  "Concert": "Concert",
  "Sports": "Sports",
  "Expo": "Expo",
  "contactInfo": "Contact Info",
  "description": "Description",
  "website": "Website",
  "chooseImage": "Choose Image",
  "cancel": "Cancel",
  "save": "Save",
  "update": "Update",
  "newEvent": "New Event",
  "editEvent": "Edit Event",
  "fillRequiredFields": "Please fill all required fields.",
  "login_2fa_required": "2FA Required",
  "titleRequired": "Title is required.",
  "minutes":"Minutes",
  "dateRequired": "Date is required.",
  "locationRequired": "Location is required.",
  "eventTypeRequired": "Event type is required.",
  "register_email_domain_error":`Please enter an email with the extension @${emailDomain}`,
  "notSpecified":"Not Specified",
  "contactInfoRequired": "Contact info is required.",
  "descriptionRequired": "Description is required.",
  "genericError": "An error occurred.",
  "createdSuccess": "Event created successfully.",
  "updatedSuccess": "Event updated successfully.",
   "confirmDeleteEvent": "Are you sure you want to delete the event?",
  "eventDeleted": "Event deleted successfully.",
  "eventDeleteError": "An error occurred while deleting the event.",
  "gotoHere": "Go to Here",
  "register_student_no":"Student No",
  "register_community":"Community",
  "deleteEvent":"Delete Event",
  "register_community_optional":"Student Community",
  "kampus_search": "Search on Campus",
  "yuruyus_cemberlerini_ac":"Open Walking Circles",
  "yuruyus_cemberlerini_kapat":"Close Walking Circles",
  "dialog.roleSelection":"Role Selection",
  "register_back": "Back",
  "student_communities":"Student Communities Events",
  "no_community_events":"No Registered Events Available.",
  "register_role_student": "Student",
  "register_role_personel": "Personnel",
  "register_unit_label": "Choose Units",
  "changePassword": {
    "title": "Set New Password",
    "info": "For your security, you must change your password.",
    "errors": {
      "required": "Please fill in both password fields.",
      "mismatch": "Passwords must match.",
      "default": "An error occurred while updating your password."
    },
    "fields": {
      "newPassword": "New Password",
      "confirmPassword": "Confirm New Password"
    },
    "actions": {
      "submit": "Update"
    }
  },
  "forgot_password_title": "Forgot Password",
  "forgot_password_instructions": "Enter your registered email; we will send you a code.",
  "email_label": "Email",
  "email_required": "Email is required.",
  "send_code_button": "Send Code",
  "forgot_password_error": "An error occurred while sending the code.",
  "forgot_password_link":"Forgot My Password",
    }
  },
  tr: {
    translation: {
      "changePassword": {
    "title": "Yeni Şifre Belirle",
    "info": "Güvenliğiniz için şifrenizi değiştirmeniz gerekli.",
    "errors": {
      "required": "Lütfen her iki alana da şifre girin.",
      "mismatch": "Şifreler eşleşmeli.",
      "default": "Şifre güncellenirken hata oluştu."
    },
    "fields": {
      "newPassword": "Yeni Şifre",
      "confirmPassword": "Yeni Şifre (Tekrar)"
    },
    "actions": {
      "submit": "Güncelle"
    }
  },
  "forgot_password_title": "Şifremi Unuttum",
  "forgot_password_instructions": "Kayıtlı e-postanızı girin; size bir kod göndereceğiz.",
  "email_label": "E-posta",
  "email_required": "E-posta gerekli.",
  "send_code_button": "Kod Gönder",
  "forgot_password_error": "Gönderilirken hata oluştu.",
        "register_back": "Geri",
  "register_role_student": "Öğrenci",
  "register_role_personel": "Personel",
  "register_unit_label": "Birim Seçin",
      "register_student_no":"Öğrenci No",
      "register_community":"Öğrenci Topluluğu",
      "register_community_optional":"Öğrenci Topluluğu",
       "confirmDeleteEvent": "Etkinliği silmek istediğinize emin misiniz?",
  "eventDeleted": "Etkinlik başarıyla silindi.",
  "eventDeleteError": "Etkinlik silinirken hata oluştu.",
  "gotoHere": "Buraya Git",
       "title": "Başlık",
  "date": "Tarih",
  "time": "Saat",
  "Ceremony":"Tören",
  "location": "Konum",
  "eventType": "Etkinlik Türü",
  "Seminar": "Seminer",
  "Workshop": "Atölye Çalışması",
  "Concert": "Konser",
  "Sports": "Spor",
  hacettepe: process.env.REACT_APP_SIDEBAR_LABEL || 'Hacettepe',
  "register_email_domain_error":`Lütfen uzantısı @${emailDomain} olan bir e-posta giriniz`,
  "harita":"Harita",
  "Expo": "Fuar",
  "contactInfo": "İletişim Bilgisi",
  "description": "Açıklama",
  "website": "Web Sitesi",
  "notSpecified":"Belirtilmemiş",
  "chooseImage": "Resim Seç",
  "cancel": "İptal",
  "Cultural and Artistic Events":"Kültürel ve Sanatsal Etkinlikler",
  "Symposium":"Sempozyum",
  "save": "Kaydet",
  "Thesis Defense":"Tez Savunması",
  "update": "Güncelle",
  "newEvent": "Yeni Etkinlik",
  "editEvent": "Etkinliği Düzenle",
  "fillRequiredFields": "Lütfen tüm zorunlu alanları doldurun.",
  "titleRequired": "Başlık gereklidir.",
  "student_communities":"Öğrenci Toplulukları Etkinlikleri",
  "forgot_password_link":"Şifremi Unuttum",
  "dateRequired": "Tarih gereklidir.",
  "locationRequired": "Konum gereklidir.",
  "login_2fa_required": "2FA Kodu Gereklidir",
  "eventTypeRequired": "Etkinlik türü gereklidir.",
  "contactInfoRequired": "İletişim bilgisi gereklidir.",
  "descriptionRequired": "Açıklama gereklidir.",
  "genericError": "Bir hata oluştu.",
  "createdSuccess": "Etkinlik başarıyla oluşturuldu.",
  "updatedSuccess": "Etkinlik başarıyla güncellendi.",
      "clear_map": "Haritayı Temizle",
        "add_unit": "Birim Ekle",
  "name": "Ad",
  "description": "Açıklama",
  "website": "Web Sitesi",
  "telephone": "Telefon",
  "location": "Konum",
  "cancel": "İptal",
  "add": "Ekle",
      "add_unit":"Birim Ekle",
      "login_form_title":     "Giriş Yap",
      "login_email":          "E-posta",
      "login_password":       "Parola",
      "login_missing_fields": "Lütfen e-posta ve parolayı girin",
      "login_inactive":       "Hesabınız aktif değil. Lütfen e-postanızı kontrol edin",
      "login_failed":         "Giriş başarısız",
      "login_error":          "Giriş sırasında bir hata oluştu",
      "register_missing_fields":       "Lütfen tüm alanları doldurun",
      "register_password_mismatch":    "Parolalar eşleşmiyor",
      "register_invalid_email":        "Geçersiz e-posta adresi",
      "register_form_title":           "Kayıt Formu",
      "register_name":                 "İsim",
      "register_surname":              "Soyisim",
      "register_email":                "E-posta",
      "register_username":             "Kullanıcı Adı",
      "register_password":             "Parola",
      "register_confirm_password":     "Parolayı Onayla",
      "register_role_label":           "Rol",
      "role_editor":                   "Editör",
      "role_admin":                    "Yönetici",
      "register_loading":              "Kayıt yapılıyor...",
      "register_check_email":          "Lütfen aktivasyon maili için e-postanızı kontrol edin",
      "register_failed":               "Kayıt başarısız oldu",
      "register_error":                "Kayıt sırasında bir hata oluştu",
      "swap_points":"Başlangıç ve Bitiş Noktasını Değiştir",
      "konumumu_kullan": "Konumumu Kullan",
      "hatalar": "Hatalar",
      "edit_unit":"Birimi Düzenle",
      "arama_hatasi": "Arama sırasında bir hata oluştu.",
      "geolocation_destegi_yok": "Geolocation API desteği yok.",
      "konumum": "Konumum",
      "konum_alindi": "Konumunuz başarıyla alındı.",
      "konum_alinirken_hata": "Konumunuzu alırken bir hata oluştu.",
      "baslangic_noktasi": "Başlangıç Noktası",
      "vasita_turu": "Vasıta Türü",
      "yaya": "Yaya",
      "bisiklet": "Bisiklet",
      "haritadan_secmek_icin_haritaya_tiklayin":"Kapalı alan içerisinden seçim yapınız", 
      "arac": "Araç",
      "yuruyus_cemberlerini_ac":"Yürüyüş Çemberlerini Aç",
      "yuruyus_cemberlerini_kapat":"Yürüyüş Çemberlerini Kapat",
      "rota_hesapla": "Rota Hesapla",
      "arama": "Arama",
      "ara": "Ara",
      "hacettepe_harita": "Hacettepe Harita",
      "street_view": "Sokak Görünümü",
      "add_event": "Etkinlik Ekle",
      "add_unit": "Birim Ekle",
      "add_error": "Hata Ekle",
      "bitis_noktasi": "Bitiş Noktası",
      "baslangic": "Başlangıç",
      "bitis": "Bitiş",
      "etkinlik_detaylari": "Etkinlik Detayları",
      "tarih": "Tarih",
      "saat": "Saat",
      "yer": "Yer",
      "tur": "Tür",
      "events": "Etkinlikler",
      "units": "Birimler",
      "iletisim": "İletişim",
      "aciklama": "Açıklama",
      "cancel": "İptal",
      "edit_event":"Etkinlik Düzenle",
      "save": "Kaydet",
      "street_view_instructions": "Sokak görünümü için haritadan bir nokta seçin.",
      "yandex_street_view_opening": "Yandex Haritalar Sokak Görünümü açılıyor...",
      "unit_fields_required": "İsim, Enlem ve Boylam gereklidir.",
      "invalid_coordinates": "Geçerli koordinatlar giriniz.",
      "unit_updated": "Birim başarıyla güncellendi.",
      "unit_update_error": "Birim güncellenirken bir sorun oluştu.",
      "event_not_found": "Etkinlik verisi bulunamadı.",
      "all_fields_required": "Tüm alanları doldurmanız gerekmektedir.",
      "event_updated": "Etkinlik başarıyla güncellendi.",
      "event_update_error": "Etkinlik güncellenirken bir hata oluştu.",
      "select_start_end": "Lütfen başlangıç ve bitiş noktalarını seçin.",
      "route_calculated": "Rota başarıyla hesaplandı.",
      "route_not_found": "Rota bulunamadı.",
      "route_error": "Rota hesaplanırken bir sorun oluştu.",
      "reverse_geocoding_error": "Yeni konumun adı alınırken bir hata oluştu.",
      "show_details": "Detayları Göster",
      "distance_label": "Mesafe:",
      "goto_here":"Buraya Git",
      "mesafe_unit": "m",
      "edit_unit": "Birim Düzenle",
      "name": "İsim",
      "description": "Açıklama",
      "latitude": "Enlem",
      "longitude": "Boylam",
      "login_form_title": "Giriş Yap",
      "login_username": "Kullanıcı Adı",
      "login_password": "Şifre",
      "login_missing_fields": "Lütfen kullanıcı adı ve şifre girin.",
      "login_failed": "Giriş başarısız",
      "login_error": "Giriş sırasında bir hata oluştu.",
      "register_form_title": "Kayıt Ol",
      "register_username": "Kullanıcı Adı",
      "register_password": "Şifre",
      "register_role_label": "Rol Seçin",
      "kampus_search": "Kampüs içerisinde Arama",
      "role_normal": "Normal",
      "role_editor": "Editör",
      "role_admin": "Admin",
      "register_missing_fields": "Lütfen tüm alanları doldurun.",
      "register_success": "Kayıt başarılı! Şimdi giriş yapabilirsiniz.",
      "register_failed": "Kayıt başarısız",
      "register_error": "Kayıt sırasında bir hata oluştu.",
      "login_success": "Giriş başarılı!",
      "logout_success": "Çıkış yapıldı.",
      "route_calculating": "Rota hesaplanıyor...",
      "search_navigating": "Arama sonucuna gidiliyor...",
      "select_start_instruction": "Haritada başlangıç noktasını seçmek için tıklayın.",
      "select_end_instruction": "Haritada bitiş noktasını seçmek için tıklayın.",
      "start_point_selected": "Başlangıç noktası seçildi.",
      "end_point_selected": "Bitiş noktası seçildi.",
      "unit_selected": "seçildi.",
      "unit_panel": "Birimler",
      "login_button": "Giriş Yap",
      "no_community_events":"Kayıtlı Etkinlik Mevcut Değildir.",
      "register_button": "Kayıt Ol",
      "welcome_message": "Hoş geldiniz, {{username}}",
      "logout_button": "Çıkış Yap",
      "confirm_delete_event": "Bu etkinliği silmek istediğinizden emin misiniz?",
      "event_deleted": "Etkinlik başarıyla silindi.",
      "event_delete_error": "Etkinlik silinirken bir hata oluştu.",
      "delete_event":"Etkinlik Sil",
      "standart_page":"Standart Görünüm",
      "satellite_page":"Uydu Görünümü",
      "deleteEvent":"Etkinlik Sil",
      "searchInUnits":"Birimlerde Ara...",
      "Course":"Kurs",
      "minutes":"Dakika",
      "dialog.roleSelection":"Rol Seçimi",
      // Diğer metinler...
    }
  }
};

i18n
  .use(LanguageDetector) // Tarayıcı dilini otomatik algılamak için
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en', // Tarayıcı dili desteklenmiyorsa İngilizce'yi kullan
    debug: true, // Konsolda hata ayıklamak için
    detection: {
      order: ['navigator', 'localStorage', 'cookie'], // Dil tespiti sırası
      caches: ['localStorage', 'cookie'] // Seçilen dili sakla
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
